import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';
import { CHECKOUT_URL } from '../data/product';
const included = ['6 volumes · 300 landscape pages', '59 Ready-Run Sessions for kids, teens & rec groups', '29 printable worksheets, trackers & planners', '16 named coaching frameworks', '5 bonuses, incl. the 30-Day Quick-Start Roadmap', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-148" data-mp="1ru166g7t24cv">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-149" data-mp="25tsogt5cu6wo">
        <div className="text-center" data-id="element-150" data-mp="20slfiqrh71of">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-151" data-mp="20rjxg2c1lex7">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-152" data-mp="3c8a6rubrimv1">
            A full year of parkour classes, ready to run
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy-line bg-navy-card shadow-card" data-id="element-153" data-mp="4s49x6ox4jfs">
          <div className="bg-gold px-5 py-5 text-center" data-id="element-154" data-mp="9tjvr0yx6tz8">
            <h3 className="font-display text-xl uppercase tracking-wide text-gold-ink sm:text-2xl" data-id="element-155" data-mp="er1vq1uylyv3">
              The Parkour Class-Ready Megapack
            </h3>
            <p className="mt-1 text-[13px] font-bold uppercase tracking-widest text-gold-ink/75" data-id="element-156" data-mp="3dasavd29jfq9">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-157" data-mp="3n63rk0x8ex0n">
            <div className="overflow-hidden rounded-2xl bg-navy-deep ring-1 ring-navy-line" data-id="element-158" data-mp="3n52570armo3m">
              <ProductStack framed={false} lazy data-id="element-159" data-mp="3rz6f9sfbvc8x" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-160" data-mp="2uhek7k5l1vgg">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-161" data-mp="2zg9epjcwx8ge">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-162" data-mp="2rg34o4c060nz">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-163" data-mp="2mh8n15prui5g" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-164" data-mp="2w8w9stbdvb0l">
              <p className="text-[13px] text-ink-soft" data-id="element-165" data-mp="28h7b8v7yxqb7">
                Total value <span className="text-ink-muted line-through" data-id="element-166" data-mp="23ixfaief6loj">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-167" data-mp="23la7rpht0efu">
                <span className="mt-2.5 font-display text-3xl" data-id="element-168" data-mp="2ihhougxx0zqw">$</span>
                <span className="font-display text-[56px] leading-[0.9] sm:text-7xl" data-id="element-169" data-mp="2dg228kg3al6e">27</span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-170" data-mp="3tuk3h6ggff8f">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-171" data-mp="3ov7ae3yzpbxe">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-172" data-mp="9udy4r1spjr">
                  Save $70
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-173" data-mp="3nfcyqnorql5b">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-174" data-mp="j152wgd7qs90">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-175" data-mp="a9cvyfnee196">
                Get the Megapack — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-176" data-mp="e8llf8bencyx">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-177" data-mp="16qft53wxt48w">
                <li className="flex items-center gap-1.5" data-id="element-178" data-mp="3f81qsr9pewm8">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-179" data-mp="3f5fjmsqq6j4j" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-180" data-mp="358t0c8e1s04m">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-181" data-mp="35bf8a94uohnd" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-182" data-mp="1t5elila8r9v">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-183" data-mp="1uq9587lka7q" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-184" data-mp="3o5u9m5emwmed">
          Price in USD. You&apos;ll be charged the equivalent in your local currency.
        </p>
      </div>
    </section>;
}